@import '../../styles/palette.scss';
@import '../../styles/mixins.scss';
@import '../../styles/fonts.scss';
@import '../../styles/deviceBreakpoints.scss';

.notificationContainer {
  left: 40%;
  max-width: 35em;
  pointer-events: none;
  position: fixed;
  z-index: 9999;

  %notification {
    border-radius: 3px;
    box-shadow: 0 0 10px #999;
    color: _palette(text-white);
    display: flex;
    margin-top: 1vh;
    max-height: 10em;
    min-width: 20em;
    overflow: hidden;
    padding: 0.75em;
    pointer-events: auto;
    position: relative;
    z-index: 9998;

    @include target(mobile) {
      left: 5%;
    }
  }

  .notificationError {
    @extend %notification;
    background: _palette(text-red);
  }

  .notificationWarning {
    @extend %notification;
    color: _palette(text-primary);
    background: _palette(warning-icon);

    button {
      color: _palette(text-primary);
    }
  }

  .notificationSuccess {
    @extend %notification;
    background: darkgreen;
  }

  .notificationRemove {
    @extend %notification;
    background: _palette(student-menu-color);
    cursor: pointer;

    &:hover {
      background-color: _palette(close-icon);
    }

    div {
      margin: auto;
    }
  }

  .notificationImage {
    margin: auto 1em auto auto;
  }
}

.notificationContainer button {
  background: none;
  border: none;
  color: _palette(text-white);
  cursor: pointer;
  float: right;
  margin: auto;
  outline: none;
  padding: 1px;
  position: relative;
}

.notificationStatus {
  @include barlowMedium(16);
  text-align: left;
}

.notificationMessage {
  @include barlow(14);
  margin: auto;
  overflow: hidden;
  text-align: left;
}
